import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/ImportantLinks.css";
import { AbstractAPI } from "../api";


const ImportantLinks = () => {
  const navigate = useNavigate();
  const [linkSections, setLinkSections] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    fetchLinks();
  }, []);

const fetchLinks = async () => {
  try {
    const data = await AbstractAPI.getAllImportantLinks();

    // 🔹 Sort by ID ASC
    const sortedData = data.sort((a, b) => a.id - b.id);

    // 🔹 Group by heading
    const grouped = sortedData.reduce((acc, item) => {
      if (!acc[item.heading]) acc[item.heading] = [];

      acc[item.heading].push({
        title: item.title,
        url: item.url,
      });

      return acc;
    }, {});

    // 🔹 Convert to UI structure
    const sections = Object.keys(grouped).map((heading) => ({
      heading,
      links: grouped[heading],
    }));

    setLinkSections(sections);
  } catch (error) {
    console.error("Failed to load important links", error);
  } finally {
    setLoading(false);
  }
};

  /* ================= UI ================= */
  if (loading) {
    return <div className="important-links-page">Loading...</div>;
  }

  return (
    <div className="important-links-page">
      <div className="important-top-bar">
        <button className="clear-filters-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h2 className="important-title">Important Links</h2>
      </div>

      <div className="important-links-wrapper">
        {linkSections.length === 0 ? (
          <p>No links available</p>
        ) : (
          linkSections.map((section, index) => (
            <div key={index} className="important-link-section">
              <h3
                className="important-heading-click"
              >
                {section.heading}
              </h3>

              <table className="important-links-table">
                <tbody>
                  {section.links.map((link, idx) => (   
                    <tr key={idx}>
                      <td className="important-link-title" onClick={() => window.open(link.url, "_blank")}>
                        {link.title}
                      </td>
                      <td className="important-link-action">
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View →
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ImportantLinks;
